/**
 * Custom hook that queries for data with
 * Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import { graphql, useStaticQuery } from 'gatsby';

function useMensCollectionGraphQL() {
  const data = useStaticQuery(
    graphql`
      {
        mensCollectionHeroImage: file(
          relativePath: { eq: "collections/mens/hero-mens.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        mensGregNormanImage: file(
          relativePath: { eq: "collections/mens/card-greg-norman.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        mensTravisMatthewsImage: file(
          relativePath: { eq: "collections/mens/card-travis-matthews.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 520) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        mensBermudaSandsImage: file(
          relativePath: { eq: "collections/mens/card-bermuda-sands.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 860) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        mensFootwearImage: file(
          relativePath: { eq: "collections/mens/ibkul-men2.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        mensEvokeHeadwearImage: file(
          relativePath: { eq: "collections/mens/card-evoke-headwear.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 520) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        mensCutterAndBuckImage: file(
          relativePath: { eq: "collections/mens/sporte-leisure.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 860) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );
  return data;
}

export { useMensCollectionGraphQL };
